import React from 'react';
import { useSubmitStatus } from '../../contexts/submit-status-context';
import { FadeOut } from './fade-out';
import { SubmitErrorMessage } from './submit-error-message';
import { SubmitThankYouMessage } from './submit-thank-you-message';
export const SubmitStatusMessage = ()=>{
    const { submitSuccessMessage, submitFailureCode, submitFailureMessage } = useSubmitStatus();
    return /*#__PURE__*/ React.createElement("div", {
        role: "region",
        "aria-live": "polite"
    }, /*#__PURE__*/ React.createElement(FadeOut, {
        visible: !!submitSuccessMessage
    }, /*#__PURE__*/ React.createElement(SubmitThankYouMessage, {
        messageText: submitSuccessMessage
    })), /*#__PURE__*/ React.createElement(SubmitErrorMessage, {
        errorMessageCode: submitFailureCode,
        errorMessage: submitFailureMessage
    }));
};

//# sourceMappingURL=submit-status-message.js.map